import { create } from 'zustand';
import { GroupTreeItem } from '~apis/custom-label';

import { TreeData } from '../types';

interface Store {
  groupLabelTree: TreeData<GroupTreeItem>[];
  setGroupLabelTree: (data: TreeData<GroupTreeItem>[]) => void;
}

const initialState: Omit<Store, 'setGroupLabelTree'> = {
  groupLabelTree: [],
};

const useGroupLabelTreeStore = create<Store>((set) => ({
  ...initialState,
  setGroupLabelTree: (data) => set({ groupLabelTree: data }),
}));

export default useGroupLabelTreeStore;
